export default "__VITE_ASSET__CryvTfoE__"